
import { useTranslate } from '../../../components/TranslationText';
import { getFileName } from '../../../helper/getFileName';
import PillBtn from '../../../components/PillBtn';
import { aedLogoStyle, getDirhamImage } from '../../../common/cssclasses';
import { ImageSize } from '../../../constants/sizes';
import { formatDateTimeToString } from '../../../helper/formatDateTimeToString';
import { setReturnTicket } from '../../../helper/pageFilterPersistence';

export default function SemenCard({ horse = {} }) {
    const { translate } = useTranslate();
    const currentlang = localStorage.getItem('eahsLang') ?? 'en';
    const BaseURL = process.env.REACT_APP_UMBRACO_MEDIA_BASE_URL;

    return (
        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 mb-main">
            <div className='bg-white  rtl   p-main border-15 p-3 h-100 d-flex flex-column' >
                <div className="mb-form-group">
                    <div className='position-relative border-15' style={{ overflow: 'hidden' }}>
                        <img
                            src={horse?.stallionImage?.fileUrl}
                            className="w-100 border-15"
                            height={ImageSize}
                            alt={getFileName(horse?.stallionImage?.fileUrl)}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = `${BaseURL}/assets/img/horseauction.png`;
                                e.target.style.display = 'none';
                            }} />
                    </div>
                </div>
                <div className='d-flex justify-content-between align-items-start mb-form-group gap-2'>
                    <div className='horseCardTitle mb-0 text-wrap mt-1'>
                        {!!horse?.regNr && `${horse?.regNr} - `}  {horse?.stallionName} {translate('web.semen', 'semen')}
                    </div>
                    <div className='text-end bg-light p-2 rounded' style={{ flexShrink: 0, fontSize: 13, minWidth: 'max-content', border: '1px solid #eaeaea' }}>
                        <span className="fw-bold" style={{ color: '#666' }}>
                            <img src={getDirhamImage(currentlang)} alt='AED' style={aedLogoStyle} />
                            {translate("web.price", "Price")}
                        </span>
                        <span className="fw-bold ms-2 C89C66">
                            {horse?.price?.toLocaleString("en-US")} {translate('web.aed', 'AED')}
                        </span>
                    </div>
                </div>
                <div className='horseCardDescription row mb-form-group'>
                    {detailsRow('fa fa-calendar', 'web.birthDate', formatDateTimeToString(horse?.stallionBirthDate))}
                    {detailsRow('fa fa-palette', 'web.color', horse?.colorName)}
                    {detailsRow('fa fa-chess-knight', 'web.sire', horse?.sireName)}
                    {detailsRow('fa fa-chess-knight', 'web.dam', horse?.damName)}
                    {detailsRow('fa fa-solid fa-earth-americas', 'web.origin', horse?.originName)}
                    {detailsRow('fa fa-user', 'web.owner', horse?.ownerName)}
                    {/* {detailsRow('fa fa-location-dot', 'web.address', horse?.address)} */}
                </div>
                <div className='row rtl mt-auto'>
                    <div className="col-sm-6 col-md-6 col-12 mb-sm-0 mb-3" onClick={() => setReturnTicket("semen_return_from_details")}>
                        <PillBtn
                            onClick={() => setReturnTicket("semen_return_from_details")}
                            isNoMargin
                            routeName={`/semenDetails?id=${horse?.id}`}
                            text={translate('web.viewDetails', 'View Details')}
                            isRed={true} />
                    </div>
                    <div className={"col-sm-6 col-md-6 col-12 "} onClick={() => setReturnTicket("semen_return_from_details")}>
                        <PillBtn
                            onClick={() => setReturnTicket("semen_return_from_details")}
                            isNoMargin
                            text={translate("web.StudBookDetails", "StudBook Details")}
                            routeName={`/horsedetails?horseId=${horse?.stallionId}&title=${encodeURIComponent(horse?.name || '')}`} />
                    </div>
                </div>
            </div>
        </div>
    )

    function detailsRow(icon = '', key = "", value = "") {
        return <div className='col-6'>
            <span className="fw-bold">
                <i className={`${icon} C89C66 me-2`} />
                {translate(key, key) + ": "}
            </span>
            <span className="fw-bold ms-2">
                {!!value
                    ? value
                    : ""}
            </span>
        </div>;
    }
}
